import { render, staticRenderFns } from "./TimelineStatus.vue?vue&type=template&id=22594f41&"
import script from "./TimelineStatus.vue?vue&type=script&lang=js&"
export * from "./TimelineStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline})
